<template>
  <div class="md:mx-4 lg:mx-8 text-dark">
    <div class="text-center ">
        <div class="flex items-center justify-center">
          <img src="@/assets/images/oneweek.png" alt="Image" class="mx-auto w-full lg:w-2/3">

        </div>
        <h3 class="text-2xl font-black text-black mt-2">achievement</h3>

        <h1 class="text-5xl font-black text-black mb-2">weeklong mastery</h1>

        <div class="my-6">
            A week may seem like a small unit of time, but it has the power to create significant and lasting change in our lives.

        </div>

        <div class="flex items-center justify-center mt-4">
            <vs-button icon-pack="feather" icon="icon-arrow-right" @click="save">continue on the journey</vs-button>
        </div>

        <div class="font-italic font-sm mt-2">
          *Share your successes like you share memes, the internet deserves to know.
        </div>
    </div>
  </div>

</template>

<script>

export default {
  components: {
  },
  data () {
   return {
    }
  },
  computed: {
  },
  methods: {
    save () {
      this.$emit('hidePopup')
    }
  }
}
</script>
